"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSIDE_CANADA_APPLICATION_QUESTION_GROUPS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const Questions = require("../../questions/questions");
const answer_1 = require("../../utils/answer");
const group_1 = require("../../utils/group");
const { Question } = Questions;
exports.INSIDE_CANADA_APPLICATION_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "DETAILS_VISIT_INSIDE_CANADA_ALL_QUESTIONS",
        title: "Information about your visit",
        subtitle: undefined,
        id: 108,
        content: [
            Question["What is the purpose of your visit?"]
                .label("TR_21")
                .ifAnswerEquals("Other")
                .renderTheseQuestions([
                Question["What is the other purpose of your visit?"].label("TR_22"),
            ]),
            Question["What day will you be arriving?"].label("TR_1"),
            Question["What day will you be leaving?"].label("TR_2"),
            Question["What is the total amount of funds you have available for your visit?"].label("TR_3"),
            Question["Who will pay for your expenses while in Canada?"]
                .label("TR_19")
                .ifAnswerEquals("Other")
                .renderTheseQuestions([
                Question["Who (other) will pay for your expenses while in Canada?"].label("TR_20"),
            ]),
            Question["Who will you be visiting while you are in Canada?"].label("HEAD_10"),
            Question["Full name of person or institution"].label("TR_4"),
            Question["How do you know them?"].label("TR_5"),
            Question["What is their full address in Canada?"].label("TR_6"),
            Question["Will you be visiting anyone else in while Canada?"]
                .label("TR_7")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Full name of person or institution"].label("TR_8"),
                Question["How do you know them?"].label("TR_9"),
                Question["What is their full address in Canada?"].label("TR_10"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "DETAILS_VISIT_INSIDE_CANADA_NO_PURPOSE",
        title: "Information about your visit",
        subtitle: undefined,
        id: 111,
        content: [
            Question["What day will you be arriving?"].label("TR_1"),
            Question["What day will you be leaving?"].label("TR_2"),
            Question["What is the total amount of funds you have available for your visit?"].label("TR_3"),
            Question["Who will pay for your expenses while in Canada?"]
                .label("TR_19")
                .ifAnswerEquals("Other")
                .renderTheseQuestions([
                Question["Who (other) will pay for your expenses while in Canada?"].label("TR_20"),
            ]),
            Question["Who will you be visiting while you are in Canada?"].label("HEAD_10"),
            Question["Full name of person or institution"].label("TR_4"),
            Question["How do you know them?"].label("TR_5"),
            Question["What is their full address in Canada?"].label("TR_6"),
            Question["Will you be visiting anyone else in while Canada?"]
                .label("TR_7")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Full name of person or institution"].label("TR_8"),
                Question["How do you know them?"].label("TR_9"),
                Question["What is their full address in Canada?"].label("TR_10"),
            ]),
        ],
    }),
];
